
    import '/home/ec2-user/Youlify-Design/components/icon/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["icon-demo-basic","icon-demo-two-tone","icon-demo-custom","icon-demo-iconfont","icon-demo-scripturl"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/icon/index.en-US.md?type=demo')
};